import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { GetLocalSettingsEffects } from './store/get-local-settings.effects';
import { reducer } from './store/get-local-settings.reducers';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ GetLocalSettingsEffects ]),
    StoreModule.forFeature('getLocalSettings', reducer),
  ]
})
export class GetLocalSettingsModule {}
